export default {
  navbar: {
    Home: 'HOME',
    ProductInfo: 'PRODUCT',
    Contact: 'CONTACT',
    Join: 'JOIN',
    About: 'ABOUT',
    TMS: 'TMS Transportation Management System',
    SCC: 'SCC Order Collaboration Platform',
    DAT: 'DATAHUB Data Exchange Platform',
    OMS: 'OMS Order Management System',
    WCS: 'WCS Equipment Control System',
    WMS: 'WMS Warehouse Management System',
    zh: 'Chinese'
  },
  // 首页
  Home: {
    bannerTitle: 'MAG TMS transportation management',
    bannerDetail: 'Intelligence, transparency, visualization and whole process',
    bannerButton: 'Detail',
    bannerTitle1: 'We optimize your supply chain',
    bannerDetail1: 'Integrated automated logistics solution for warehousing, distribution and manufacturing',
    bannerTitle2: 'MAG SCC Order collaboration platform',
    bannerDetail2: 'Build excellent supply chain management center',
    system1: {
      Title: 'WMS Warehouse Management System',
      Detail1: 'The real production and fine warehouse management system',
      Detail2: 'High applicability and flexibility',
      Detail3: 'The brain of intelligent logistics warehouse',
      Detail4: 'Warehouse oriented efficiency improvement'
    },
    system2: {
      Title: 'OMS Order Management System',
      Detail1: 'Multi platform, multi warehouse and multi store integrated management',
      Detail2: 'Online and offline, efficient collaboration',
      Detail3: 'Powerful report function, fearless big data query'
    },
    system3: {
      Title: 'TMS Logistics Management System',
      Detail1: 'Intelligent, transparent and whole process',
      Detail2: 'Facing five challenges of transportation management',
      Detail3: 'Professional solutions'
    },
    system4: {
      Title: 'OCP Order Collaboration Platform',
      Detail1: 'Multi system collaboration',
      Detail2: 'Configurable automation engine',
      Detail3: 'Order lifecycle management'
    },
    LookDetail: 'Detail',
    // 方案
    scheme: {
      Title: 'Your Supply Chain Optimization Plan',
      Name1: 'MAG WMS warehouse management system',
      NameCopy: 'Performance optimization software',
      Detail1: {
        Detail1: 'Integrating business practices of hundreds of industries and enterprises',
        Detail2: 'Highly product oriented, covering all business requirements of warehouse',
        Detail3: 'Intelligent operation guidance, optimized operation process and strategy',
        Detail4: 'Omni channel business support, paperless operation management'
      },
      Name2: 'MAG TMS transportation management system',
      Detail2: {
        Detail1: 'Transportation management process information, visualization, intelligence',
        Detail2: 'Static route planning and dynamic route optimization',
        Detail3: 'Carrier management, collaborative order management',
        Detail4: 'Intelligent transportation tracking and handling'
      },
      Name3: 'MAG DATAHUB data exchange platform',
      Detail3: {
        Detail1: 'Data exchange and docking between systems',
        Detail2: 'Docking of software system and hardware system',
        Detail3: 'Docking with mainstream ERP software and logistics automation equipment',
        Detail4: 'Multi client, heterogeneous system, large data processing capacity'
      },
      Name4: 'MAG SCC Order collaboration platform',
      Detail4: {
        Detail1: 'Whole network inventory makes inventory management easier and more transparent',
        Detail2: 'Multi system collaboration, open platform for suppliers and customers, serving the whole supply chain',
        Detail3: 'Configurable automation engine, multiple application scenarios, greatly improving the overall efficiency',
        Detail4: 'Order life cycle, flexible node configuration, multi-mode message warning'
      },
      Name5: 'MAG WCS equipment control system',
      Detail5: {
        Detail1: 'Cooperate with various logistics equipment and adopt unified control platform',
        Detail2: 'Perfect support all kinds of WMS, ERP and other systems docking',
        Detail3: 'Overall consideration of control optimization of equipment',
        Detail4: 'Convenient for future equipment adjustment and expansion'
      },
      Name6: 'MAG OMS order management system',
      Detail6: {
        Detail1: 'Omni channel order management, docking multi platform',
        Detail2: 'Order merging and splitting automatically',
        Detail3: 'Auto match warehouse and express',
        Detail4: 'Multi department and multi role collaborative office'
      },
      Button: 'MORE'
    },
    // 客户案例
    CustomerCase: {
      Title: 'Customer Case',
      Detail: 'Leading management concept: high end customer group in the industry, the most mature and leading management concept in the industry; profound industry accumulation: 10 More than years of experience in R & D and implementation of information systems in many well-known enterprises; professional talent reserve: senior expert team, high-quality R & D team; comprehensive application functions: complete product line, strong business integration ability and R & D ability; reliable product quality: strict R & D process and project quality control; high-quality after-sales service: rapid, rapid and efficient The guarantee of high quality and effective characteristic after-sale service.',
      Case: {
        Case1: {
          Title: 'Truck Flight Service',
          Detail1: 'Truck flight operation system is a professional system solution for airlines such as CV, 7L, Ru launched by MAG in 2019. The system provides airlines with several functions, including customer management, truck service provider management, cargo management, message information management, truck flight management, financial management, authority management, static data management, report statistics, etc 。 Through Sita telegram, truck operating system can automatically exchange electronic data with airlines and truck service providers to further improve operation efficiency.          '
        },
        Case2: {
          Title: 'Intelligent Warehouse',
          Detail1: 'BASF is the leading chemical company in the world. BASF is well-known in Germany in parallel with Bayer and Hoechst. It is one of the three largest chemical plants in Germany. Its products include chemicals, plastics, specialty chemicals, agricultural products, fine chemicals, crude oil and natural gas.',
          Detail2: 'With the application of MEG WMS, the utilization rate of warehouse and the visualization management of the whole process of warehouse operation are significantly improved'
        },
        Case3: {
          Title: 'Third Party Logistics',
          Detail1: 'COSCO Shipping Logistics is a wholly-owned subsidiary of COSCO Shipping Group. It is the only integrated logistics service platform company of COSCO Shipping Group. It is the largest international third-party logistics enterprise in China.',
          Detail2: 'TMS products realize the transformation of COSCO"s overall process of maritime transportation management, and connect all businesses into a whole, thus establishing a unified and complete transportation business management platform for COSCO Shipping. '
        },
        Case4: {
          Title: 'Fourth Party Logistics',
          Detail1: 'With the adjustment of strategy and the rapid growth of business, a global duty-free group company has encountered a series of new challenges. MAG 4PL has a wide range of industry background, and provides comprehensive and customized supply chain solutions and consulting services for customers through its information technology, integration capabilities and other resources and capabilities in professional fields.',
          Detail2: 'Relying on the customized supply chain visualization platform (MAG SCC), it optimizes the supply chain process, helps enterprises reduce costs and effectively integrate resources, and improves the efficiency of the supply chain.'
        },
        Case5: {
          Title: 'Visualization Platform Of Free Trade Zone',
          Detail1: 'A global well-known clothing group, as a fast consumer brand, logistics is one of the groups "sharp tools", which means that the speed of harsh and picky。',
          Detail2: 'By using the visualization system of MAG Free Trade Zone, the fastest record of cargo leaving the zone within 5 hours after landing was created under the mode of "integration of district and port on the same day".',
          Detail3: 'The main functions include: import and export management, trade compliance, bonded warehouse management, additional trade management, phase II of Jinguan, distribution management, etc'
        },
        Case6: {
          Title: 'Distribution Management System',
          Detail1: 'A global automobile manufacturing group, national motorcycle distribution project in free trade zone',
          Detail2: 'MAG TMS fully supports trunk logistics, regional distribution, vehicle tracking, intelligent scheduling, and fast settlement.',
          Detail3: 'Support mobile device application, realize comprehensive tracking, comprehensive information visualization.'
        }
      }
    },
    // 订货数量
    OrderQuantity: {
      Billion: 'Billion',
      year: 'Year',
      OrderNum: 'Cumulative order quantity',
      OrdeUser: 'Enterprise users',
      hangye: 'Focus on Industry',
      yanfa: 'Product development',
      content1: 'Us / Ge / transportation / management / management / cloud / Ping / Taiwan',
      content2: 'Specialty / business / material / flow / management / management'
    },
    // 企业选择
    CompanyChoose: {
      Title: 'The choice of many head Enterprises',
      button1: 'Logistics',
      button2: 'Fashion',
      button3: 'Industrial',
      button4: 'Medicine'
    }
  },
  // 合作伙伴
  Contact: {
    Title: 'Our Partners',
    Detail1: 'In order to serve customers conveniently, so far, MEG has cooperated with many well-known enterprises, such as SAP, Oracle, Dematic, etc., so that the MAG transportation collaborative platform can be implemented quickly, and the existing platform and system of the enterprise can be quickly connected, so that the in transit transportation management can quickly become a new weapon in the enterprise logistics management supply chain.',
    Detail2: 'MEG has successfully built a complete set of innovation value chain. Through the integration of MAG internal teams and MAG external ecosystem of various professional resources, to provide customers with high-quality innovation practice'
  },
  About: {
    Title: 'We are MEG. Net knows us',
    smallTitle: 'Innovation sharing growth',
    list: {
      list1: {
        Title: 'About MAG',
        smallTitle: 'TMS is committed to creating a new ecology of transportation and making transportation more intelligent',
        Detail: 'TMS is a well-known transportation management cloud platform in China, with transportation management cloud system TMS and comprehensive transportation outsourcing business all orange services. From analysis, procurement, management to payment, TMS helps customers quickly optimize the supply chain, reduce costs and increase efficiency, and lead innovation.'
      },
      list2: {
        Title: 'MAG Vision',
        smallTitle: 'Make a Difference',
        Detail: 'We should innovate the supply chain, improve the business model, and create value for the society; we should lead the innovation and achieve extraordinary results, which will make a great difference in the world.'
      },
      list3: {
        Title: 'MAG Mission',
        smallTitle: 'Make transport smart',
        Detail: 'Create a new transportation ecology with science and technology and services, enable a data-driven, interconnected supply chain, and make transportation easier'
      }
    },
    address: 'Building 1, No.3, Lane 345, Shilong Road, Xuhui District, Shanghai'
  },
  // WCS
  WCS: {
    Title: 'MAG WCS Equipment Control System',
    smallTitle: 'Omni channel    Intellectualization    Synergy',
    name: 'System Detail',
    list: {
      list1: {
        Title: 'Receiving storage',
        Detail: 'Through the electronic collaborative processing of many warehouse operation links and business processes, the human efficiency of warehouse operation is maximized as much as possible.'
      },
      list2: {
        Title: 'Picking',
        Detail: 'With the introduction of a large number of electronic and automatic goods and equipment and the real-time connection between these goods and WMS system, the application system can make the warehouse management simpler, more efficient and more automatic, and even can complete the daily management work without professional post team'
      },
      list3: {
        Title: 'Sorting And Delivery',
        Detail: 'RFID The introduction of RFID and other technical means, the use of information system stable and accurate characteristics, timely intervention to replace part of the manual operation, reduce the system error scenarios and probability, such as warehouse delivery, lost parts, missing calculation in the warehouse and so on.'
      },
      list4: {
        Title: 'Big Data Monitoring',
        Detail: 'The introduction of RFID and other technical means, the use of information system stable and accurate characteristics, timely intervention to replace part of the manual operation, reduce the system error scenarios and probability, such as warehouse delivery, lost parts, missing calculation in the warehouse and so on.'
      }
    },
    content: {
      Title: 'Equipment Control System',
      list1: {
        Title: 'Account Management',
        Detail1: 'Account management/Authority management/Role management'
      },
      list2: {
        Title: 'Device Management',
        Detail1: 'Equipment master data management / Equipment operation data collection',
        Detail2: 'Equipment failure log'
      },
      list3: {
        Title: 'Task Management',
        Detail1: 'Task creation/Complete reminder / Task coordination/distribute',
        Detail2: 'Task load balancing mechanism'
      },
      list4: {
        Title: 'Docking Protocol',
        Detail1: 'PLC communication protocol at the bottom of equipment / Single chip communication protocol',
        Detail2: ' TCPIP communication protocol'
      },
      list5: {
        Title: 'Report Management',
        Detail1: 'Equipment Report / Task report / Statistical report'
      },
      list6: {
        Title: 'SCADA',
        Detail1: 'Graphic monitoring interface / Equipment management site monitoring pi'
      }
    },
    Title1: 'Our Customers'
  },
  // DAT
  DAT: {
    Title: 'MAG Datahub Data Exchange Platform',
    smallTitle: 'Link · Coordination ·Share',
    name: 'Our Five Systems',
    name1: 'ERP System',
    name2: 'Logistics System',
    name3: 'Express Delivery System',
    name4: 'E-commerce Platform',
    name5: 'Hardware Drive System',
    system: {
      Title: 'System Features',
      Title_1: 'High performance architecture+Data security',
      Title_2: 'Customized configuration, flexible response to scenarios',
      Title_3: 'All round data interface support, big data support',
      Title_4: 'Real time monitoring, intuitive and convenient information display'
    }
  },
  // OMS
  OMS: {
    Title: 'MAG OMS Order Management System',
    smallTitle: 'Omni channel    Intellectualization    Synergy',
    name: 'System advantages',
    name1: 'Online and offline collaboration, efficient work',
    name2: 'Store platform warehouse transportation customer multi dimensional management multi platform management',
    name3: 'Full range standard data interface support',
    name4: 'High expansibility and configurability',
    name5: 'Powerful big data report, supported by intelligent decision-making mechanism',
    name6: 'Perfect support for cross border business',
    name7: 'Intelligent task scheduling and allocation mechanism, performance load balancing',
    list: {
      Title: 'Overview of system functions',
      list1: {
        Title: 'Receiving storage',
        Detail1: 'Express delivery strategy Minimum freight/ Volume judgment / Weight judgment',
        Detail2: 'Multi product designation / Item designation',
        Detail3: 'Member marketing / Store designation'
      },
      list2: {
        Title: 'Warehouse strategy',
        Detail1: 'Distance first / Regional priority / Inventory priority',
        Detail2: 'Item priority / Multi product priority',
        Detail3: 'Area detection / Inventory inspection'
      },
      list3: {
        Title: 'Membership strategy',
        Detail1: 'Member ranking / overlay / stop / Member / full offer / buy double / region / combination / priority / keyword / limit'
      },
      list4: {
        Title: 'Order strategy',
        Detail1: 'Exemption strategy / consolidation strategy / splitting strategy / transfer strategy',
        Detail2: 'Delivery strategy / out of stock transfer strategy / stock out release strategy',
        Detail3: 'Portfolio strategy / inventory allocation strategy',
        Detail4: 'Express order number strategy / Beijing Distribution Strategy'
      },
      list5: {
        Title: 'Inventory strategy',
        Detail1: 'Prevent batch off shelf / differential synchronization configuration',
        Detail2: 'Store synchronization ratio setting / package proportion configuration',
        Detail3: 'SKU synchronization ratio setting / Inventory alert configuration',
        Detail4: 'Pre sale synchronization setting / Inventory sharing allocation'
      },
      list6: {
        Title: 'BI analysis',
        Detail1: 'Product sales ranking / Store sales summary / Platform sales summary',
        Detail2: 'Warehouse sales summary / City Sales Ranking / Province Sales Ranking',
        Detail3: 'Store price comparison / Unsalable goods',
        Detail4: 'Pre sales KPI / After ales KPI / Settlement KPI',
        Detail5: 'Return registration KPI / Return processing KPI / Warehouse delivery KPI',
        Detail6: 'Express Delivery KPI'
      }
    }
  },
  TMS: {
    Title: 'MAG TMS Transportation Management System',
    smallTitle: 'Intellectualization  Transparency  Whole process',
    name: 'Direct attack on five major pain points of transportation management',
    name1: 'Cost control is difficult',
    name2: 'Difficult to implement and monitor',
    name3: 'It is difficult to meet the diverse needs of various industries',
    name4: 'Transportation planning and KPI assessment are difficult',
    name5: 'Solve the difficulty of system expansion and integration',
    name6: 'Meger logistics transportation solutions',
    name6Detail: 'The whole process of cargo owners, logistics companies, carriers and drivers are connected to create a visual, information-based and digital interface of the whole process from order allocation to goods signing. MEG TMS is the infrastructure to realize intelligent and digital transportation management in the information age',
    list: {
      name: 'Overview of system functions',
      list1: {
        Title: 'Basic settings',
        Detail1: 'Customer profile / Product profile',
        Detail2: 'Carrier file / Administrative Region / Delivery address',
        Detail3: 'Route management / Vehicle management / Model Management'
      },
      list2: {
        Title: 'Business rules',
        Detail1: 'System configuration / List configuration',
        Detail2: 'Scheduling rules / Tracking rules / Message push',
        Detail3: 'Bulletin board management / Timer'
      },
      list3: {
        Title: 'Order management',
        Detail1: 'Order creation / Order review',
        Detail2: 'Order inquiry / Order splitting'
      },
      list4: {
        Title: 'Dispatching management',
        Detail1: 'Delivery scheduling / Trunk line scheduling',
        Detail2: 'Local dispatching / Wave matching'
      },
      list5: {
        Title: 'Tracking execution',
        Detail1: 'Loading / Shipping confirmation / In transit tracking',
        Detail2: 'Arrival sign in / Unloading Warehousing / Receipt management',
        Detail3: 'Exception management / Image preservation'
      },
      list6: {
        Title: 'Statistical Analysis',
        Detail1: 'Delivery rate / Good delivery rate',
        Detail2: 'Personnel operation index / Vehicle load',
        Detail3: 'Transportation cost index / Customer satisfaction',
        Detail4: 'Carrier assessment / Custom query / Custom report'
      },
      list7: {
        Title: 'Billing management',
        Detail1: 'Rate setting / Expense bill / Bill invoice',
        Detail2: 'Bill verification / Expense audit',
        Detail3: 'Accounts receivable / Bills payable'
      },
      list8: {
        Title: 'APP',
        Detail1: 'Pick up / Unload / Load',
        Detail2: 'Sign in / Waybill query / Picture upload',
        Detail3: 'Interface management / Early warning'
      }
    }
  },
  // WMS
  WMS: {
    Title: 'MAG WMS Warehouse Management System',
    smallTitle: 'High efficiency · Precision · Intelligence · Automation · Traceability',
    name: 'System leadership',
    list: {
      list1: {
        Title: 'Reduce labor costs',
        Detail1: 'Through the electronic collaborative processing of many warehouse operation links and business processes, it capability support is introduced. Most of the functions that need manual operation are replaced by information technology, and the personnel organization and coordination work is handed over to the system for processing to maximize the human efficiency of warehouse operation.'
      },
      list2: {
        Title: 'Operation automation',
        Detail1: 'With the introduction of a large number of electronic and automatic goods and equipment and the real-time connection between these goods and WMS system, the application system can make the warehouse management simpler, more efficient and more automatic, and even can complete the daily management work without professional post team.'
      },
      list3: {
        Title: 'Reduce error rate',
        Detail1: 'Using the stable and accurate characteristics of the information system, timely intervene to replace part of the manual operation, reduce the system error scenarios and probability, such as warehouse delivery, lost parts, missing calculation and so on'
      },
      list4: {
        Title: 'Product traceability',
        Detail1: 'Product traceability: the establishment of WMS business data model can make special control on product traceability, quality management, product validity tracking, etc., forming a full chain product traceability system with traceable source, traceable destination and traceable responsibility.'
      },
      list5: {
        Title: 'Intelligent inventory',
        Detail1: 'No matter the warehouse location management and batch management, the concept of refinement is embodied everywhere. Detailed business rules, covering the whole process of warehouse operation, calmly and efficiently handle complex operation process. Visual management is realized by Kanban and graphical display tools.'
      },
      list6: {
        Title: 'Connect business closely',
        Detail1: 'With the introduction of WMS system, it can be directly connected with the systems used in ERP, TMS and other business links, so as to reduce the blocking of business links due to different information levels.'
      },
      list7: {
        Title: 'Deepen management and control of business analysis',
        Detail1: 'Deepening management analysis and control -- through the accumulation of large data and multi-dimensional analysis, to provide decision-makers with rapid decision-making support, and establish a comprehensive real-time monitoring and early warning mechanism for warehouse operations, optimize the operation efficiency of warehouses.'
      }
    }
  },
  // SCC
  SCC: {
    Title: 'MAG SCC Order Collaboration Platform',
    smallTitle: 'High efficiency · Precision · Intelligence · Automation · Traceability',
    name: 'System Introduction',
    content1: {
      Title: '卓越中心',
      list1: {
        Title: '需求计划',
        name1: '统计预算',
        name2: '需求感知',
        name3: '主数据<br/>管理',
        name4: '促销计划<br/>管理'
      },
      list2: {
        Title: '库存控制',
        name1: '各级库存<br/>管控',
        name2: '需求供应<br/>协同和<br/>监督',
        name3: '库存<br/>调配',
        name4: '规则<br/>管理'
      },
      list3: {
        Title: '供应计划',
        name1: 'SOP<br/>制定',
        name2: '订单<br/>跟踪',
        name3: '补货<br/>管理',
        name4: '货运<br/>跟踪'
      },
      list4: {
        Title: '供应链控制',
        name1: '供应链<br/>战略',
        name2: '3PL/保险优化 (价格、合约)',
        name3: '网络设计 和优化',
        name4: '关务<br/>管理',
        name5: '运输<br/>计划',
        name6: '成本<br/>控制'
      },
      list5: {
        Title: '端到端协同',
        name1: '数据分析及梳理',
        name2: '全球营运流程控制',
        name3: '系统的持续升级',
        name4: '政策和职权的定义',
        name5: 'KPI定义/监督'
      },
      list6: {
        Title: 'SCC(供应链协同)',
        name1: '供应商',
        name2: '客户',
        name3: '3PL',
        name4: '经销商'
      },
      list7: {
        Title: 'DATAHUB(主数据)'
      },
      list8: {
        Title: 'WMS(仓储系统)',
        name1: '在途库存',
        name2: '第三方仓库'
      },
      list9: {
        Title: 'OMS(订单)'
      }
    },
    content2: {
      Title: 'System Function',
      list1: {
        Title: 'Forecast plan',
        name1: 'Statistical prediction',
        name2: 'Multi scenario (for inventory simulation)',
        name3: 'Plan management of cross department cooperation',
        name4: 'Global supply network planning',
        name5: 'Total demand plan and detailed demand plan',
        name6: 'Supplier capability planning',
        name7: 'Transportation route planning',
        name8: 'Result analysis (KPI reporting)',
        name9: 'Global inventory visualization'
      },
      list2: {
        Title: 'Order management',
        name1: 'Order approval',
        name2: 'Order platform input',
        name3: 'Generate sales order and hold inventory',
        name4: 'Multi level order demand management (ATP)',
        name5: 'Guanfeng tracking',
        name6: 'Order consolidation',
        name7: 'Terminal receiving management',
        name8: 'Tracking of freight track at distribution end',
        name9: 'Notice of arrival',
        name10: 'File management',
        name11: 'Distribution status display',
        name12: 'Electronic data transmission'
      },
      list3: {
        Title: 'Purchasing management',
        name1: 'Operation specification',
        name2: 'Product master data',
        name3: 'Brand business logistics management',
        name4: 'Purchase order tracking',
        name5: '3 Trade order verification',
        name6: 'Automatic error notification',
        name7: 'Purchase batch control',
        name8: 'BACKORDER management',
        name9: 'Data transmission automation',
        name10: 'Collection management',
        name11: 'Management of abnormal arrival',
        name12: 'Document audit',
        name13: 'Notice before arrival of goods',
        name14: 'KPI management of brand suppliers',
        name15: 'Receiving management',
        name16: 'Electronic data transmission'
      },
      list4: {
        Title: 'Transportation management',
        name1: 'SOP management',
        name2: 'Transportation route analysis (domestic, International)',
        name3: 'Goods management in transit',
        name4: 'Replenishment management',
        name5: 'Cross docking distribution',
        name6: 'Inventory management',
        name7: 'Returns management',
        name8: 'Shipping demand and approval',
        name9: 'Non conformance report',
        name10: 'Damage, claim, premium management',
        name11: 'Supplier (warehousing, logistics) assessment',
        name12: 'Document management',
        name13: 'Early warning management',
        name14: 'Analysis of transportation mode',
        name15: 'Trade terms management',
        name16: 'Volume analysis',
        name17: 'Transportation node control',
        name18: 'Electronic data transmission'
      },
      list5: {
        Title: 'Optimize management',
        name1: 'Control over invoices',
        name2: 'Customs management',
        name3: 'Inventory management (including effective period management)',
        name4: 'Cost control',
        name5: 'Difference analysis',
        name6: 'Order management (including delivery end)',
        name7: 'Optimal management of transportation mode route',
        name8: 'Master data management',
        name9: 'Insurance management',
        name10: 'Freight management (International, domestic)'
      }
    }
  },
  // 招纳贤士
  Join: {
    Title: 'Best employer in logistics industry',
    smallTitle: 'Innovate Share Grow up',
    list: {
      list1: {
        Title: 'Best employer in logistics industry',
        Detail1: 'WMS China brand;',
        Detail2: 'Annual growth rate of more than 40% leads the industry;',
        Detail3: 'Technology / solutions lead, customers lead.'
      },
      list2: {
        Title: 'Share success, share wealth',
        Detail1: 'Share not only success but also wealth;',
        Detail2: 'A group of intelligent and energetic people are gathered together;',
        Detail3: 'More than a quarter of honorary employees with more than five years experience'
      },
      list3: {
        Title: 'Professional training growth power',
        Detail1: 'Professional training at least once a month',
        Detail2: 'Let the staff keep knowledge leading and business proficient;',
        Detail3: 'Provide source power for the personal growth of employees.'
      },
      list4: {
        Title: 'Unique culture and humanistic care',
        Detail1: 'Caring about employees health is better than simply pursuing performance;',
        Detail2: 'Fruit time, own farm, walking every season;',
        Detail3: 'Overseas annual meeting, show you the world'
      }
    },
    banner: 'A glimpse of the annual meeting',
    info: {
      Title: 'Recruitment Information',
      list: {
        name1: 'WMS senior consultants (10)',
        name2: 'TMS senior consultants (5)',
        name3: 'Java development (5)',
        name4: 'DBA database management (2)',
        name5: 'TTMS senior consultants (5)',
        Title: 'Job responsibilities:',
        Detail1: '1. Be responsible for the implementation of WMS project, including project research, business blueprint design, functional requirements writing, installation configuration and training, etc., to ensure the timely and quality completion of the project;',
        Detail2: '2. Keep close communication with customers to solve problems encountered in the project;',
        Detail3: '3. Responsible for communication and coordination between project implementation team and development team;',
        Detail4: '4. Summarize the project implementation management experience, enrich the implementation knowledge base, and establish model customers.',
        Detail5: 'Working place: Shanghai, Beijing, Guangzhou, Shenzhen, Wuhan, Chengdu, Hefei, Qingdao',
        addressWuhan: 'Working place：Wuhan',
        addressDataBase: 'Working place：Beijing,Shanghai'
      }
    }
  },
  Footer: {
    nav: 'Website navigation',
    contact: {
      Title: 'Contact information',
      tel: 'Phone：021-54500923',
      email: 'Email：marketing@mag-chn.com',
      postal: 'Postcode：200232',
      address: 'Address: Shanghai Meige Network Technology Co., Ltd., building 1, No. 3, Lane 345, Shilong Road, Xuhui District, Shanghai',
      weixin: 'WeChat official account',
      scan: 'Scan mobile wechat',
      copyRight: 'Copyright @ 2020 mag- chn.com  Hu ICP Bei No. 19028688'
    }
  }
}
